import { linko } from "@shared/linko";
import type {
  StatisticsDailyTrendsQueryBody,
  StatisticsDailyTrendsResult,
  StatisticsHourlyTrendsQueryBody,
  StatisticsHourlyTrendsResult,
} from "./types";

/**
 * Nested manifest typing does not expose `getDailyTrends` / `getHourlyTrends`
 * on `linko.statistics.queries`. Runtime routes exist; these wrappers
 * restore a single typed call site for each.
 */
type StatisticsQueriesTrends = {
  getDailyTrends: (
    body: StatisticsDailyTrendsQueryBody,
  ) => Promise<{ data: StatisticsDailyTrendsResult }>;
  getHourlyTrends: (
    body: StatisticsHourlyTrendsQueryBody,
  ) => Promise<{ data: StatisticsHourlyTrendsResult }>;
};

export async function fetchStatisticsDailyTrends(
  body: StatisticsDailyTrendsQueryBody,
): Promise<StatisticsDailyTrendsResult> {
  const queries = linko.statistics
    .queries as unknown as StatisticsQueriesTrends;
  const { data } = await queries.getDailyTrends(body);
  return data;
}

export async function fetchStatisticsHourlyTrends(
  body: StatisticsHourlyTrendsQueryBody,
): Promise<StatisticsHourlyTrendsResult> {
  const queries = linko.statistics
    .queries as unknown as StatisticsQueriesTrends;
  const { data } = await queries.getHourlyTrends(body);
  return data;
}
